/* jshint esversion: 6 */
import { useContext, useEffect, useState } from "react";
import { MyContext } from "../../Context/MyProvider";
import axios from "axios";
import Slider from "react-slick";
import Loading from "../../Loading";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaVolumeMute, FaVolumeUp } from "react-icons/fa";

import orgenizerImg from "../../Images/orgenizer.png";
import agentImg from "../../Images/agent.png";
import franchisee from "../../Images/franchisee.png";
import dumy from "../../Images/dumy.png";
import video1 from "../../Images/video1.mp4";
import video2 from "../../Images/video2.mp4";
import video3 from "../../Images/video3.mp4";
import video4 from "../../Images/video4.mp4";
import video5 from "../../Images/video5.mp4";
import video6 from "../../Images/video6.mp4";

const businessVideo = [
    {
        id: "4",
        title: "Organizer",
        video: video1,
    },
    {
        id: "5",
        title: "Freelancer",
        video: video2,
    },
    {
        id: "2",
        title: "Freelancer",
        video: video4,
    },
    {
        id: "3",
        title: "Organizer",
        video: video5,
    },
];

const businessVideo1 = [
    {
        id: "1",
        title: "Organizer",
        video: video3,
    },
    {
        id: "6",
        title: "Freelancer",
        video: video6,
    }
];

/* ================= STATIC LOCATION (iShivax) ================= */
const STATIC_LOCATION = {
    lat: 26.9124,
    long: 75.7873,
};

const BusinessUser = () => {
    const { t } = useTranslation();

    const { BaseUrl } = useContext(MyContext);
    const [location, setLocation] = useState({ lat: null, long: null });
    const [data, setData] = useState([]);
    const [videosData, setVideosData] = useState([]);
    const [businessOrgData, setBusinessOrgData] = useState([]);
    const [formList, setFormList] = useState([]);
    const [activeVideoId, setActiveVideoId] = useState(null);
    const navigate = useNavigate();

    const bannerSettings = {
        dots: true,
        infinite: data?.length > 1,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: data?.length > 1,
        autoplaySpeed: 3000,
        arrows: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        swipe: true,
        adaptiveHeight: false,
    };

    useEffect(() => {
        const getFormData = async () => {
            try {
                const res = await axios.post(`${BaseUrl}user_api/form_list.php`);

                if (res?.data?.status) {
                    const filteredData = (res.data.data || []).filter(
                        (item) => item.form_type === "business"
                    );

                    setFormList(filteredData);
                } else {
                    setFormList([])
                }
            } catch (error) {
                setFormList([])
            }
        };

        getFormData();
    }, [BaseUrl]);

    useEffect(() => {
        const getBusinessOrgData = async () => {
            try {
                const res = await axios.get(`${BaseUrl}user_api/register_with_us.php`);

                setBusinessOrgData(res.data.data || []);
            } catch (error) {
                setBusinessOrgData([])
            }
        };

        getBusinessOrgData();
    }, [BaseUrl]);

    useEffect(() => {
        const getVideosData = async () => {
            try {
                const res = await axios.get(`${BaseUrl}user_api/business_user_videos.php`);

                if (res?.data?.status) {
                    setVideosData(res.data.data);
                } else {
                    setVideosData([])
                }
            } catch (error) {
                setVideosData([])
            }
        };

        getVideosData();
    }, [BaseUrl]);

    const handleBanner = () => {
        const Userid = localStorage.getItem("Userid") || "0";

        if (Userid) {
            axios.get(`${BaseUrl}user_api/get_banner.php`)
                .then((res) => {
                    const bannerData = Array.isArray(res?.data?.data) ? res.data.data : [];

                    // filter only business type
                    const businessData = bannerData?.filter(item => item.banner_type === "business");

                    setData(businessData);
                })
                .catch((err) => {
                    setData([]);
                });
        }
    };

    useEffect(() => {
        // if (location?.lat && location?.long) {
        handleBanner();
        // }
    }, []);

    const handleVideoSound = (videoId) => {
        setActiveVideoId((currentVideoId) =>
            currentVideoId === videoId ? null : videoId
        );
    };

    return (
        <div>
            <div className="width_container">
                <div className="dashbord">
                    {data?.length > 0 && (
                        <div className="section_1 " style={{ height: "auto" }}>
                            <div className="banner_slider_wrap w-[100%]">
                                {data?.length > 1 ? (
                                    <Slider {...bannerSettings}>
                                        {data.map((item, index) => (
                                            <div key={item.id || index}>
                                                <Link to={item.banner_link ? item.banner_link : "#"} target="_blank" rel="noopener noreferrer">
                                                    <img src={item?.image} alt="" className="rounded-xl mb-4" />
                                                </Link>
                                            </div>
                                        ))}
                                    </Slider>
                                ) : (
                                    data.map((item, index) => (
                                        <div key={item.id || index}>
                                            <Link to={item.banner_link ? item.banner_link : "#"} target="_blank" rel="noopener noreferrer">
                                                <img src={item?.image} alt="" className="rounded-xl mb-4" />
                                            </Link>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    )}

                    {/* Video Section Below Banner */}
                    <div className="business_video_section mt-4 mb-[40px]">
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 w-full">
                            {videosData
                                ?.filter((item) => item?.type === "vertical")
                                .map((item) => {
                                    const videoId = `${item.type}-${item.id}`;
                                    const isActiveVideo = activeVideoId === videoId;

                                    return (
                                        <div
                                            key={videoId}
                                            className="relative aspect-[9/16] w-full rounded-xl overflow-hidden bg-white shadow-sm mb-5"
                                        >
                                            <video
                                                src={item.video_url}
                                                className="h-full w-full rounded-xl object-cover"
                                                autoPlay
                                                muted={!isActiveVideo}
                                                loop
                                                playsInline
                                                preload="metadata"
                                            />
                                            <button
                                                type="button"
                                                onClick={() => handleVideoSound(videoId)}
                                                className="absolute bottom-3 right-3 z-10 flex h-9 w-9 items-center justify-center rounded-full bg-black/60 text-white shadow-md transition hover:bg-black/75"
                                                aria-label={isActiveVideo ? "Mute video" : "Unmute video"}
                                            >
                                                {isActiveVideo ? (
                                                    <FaVolumeUp className="text-[16px]" />
                                                ) : (
                                                    <FaVolumeMute className="text-[16px]" />
                                                )}
                                            </button>
                                        </div>
                                    );
                                })}
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xxl:grid-cols-4 gap-4 w-full mt-5">
                            {videosData
                                ?.filter((item) => item?.type === "horizontal")
                                .map((item) => {
                                    const videoId = `${item.type}-${item.id}`;
                                    const isActiveVideo = activeVideoId === videoId;

                                    return (
                                        <div
                                            key={videoId}
                                            className="relative aspect-video w-full rounded-xl overflow-hidden bg-white shadow-sm mb-5"
                                        >
                                            <video
                                                src={item.video_url}
                                                className="h-full w-full rounded-xl object-cover"
                                                autoPlay
                                                muted={!isActiveVideo}
                                                loop
                                                playsInline
                                                preload="metadata"
                                            />
                                            <button
                                                type="button"
                                                onClick={() => handleVideoSound(videoId)}
                                                className="absolute bottom-3 right-3 z-10 flex h-9 w-9 items-center justify-center rounded-full bg-black/60 text-white shadow-md transition hover:bg-black/75"
                                                aria-label={isActiveVideo ? "Mute video" : "Unmute video"}
                                            >
                                                {isActiveVideo ? (
                                                    <FaVolumeUp className="text-[16px]" />
                                                ) : (
                                                    <FaVolumeMute className="text-[16px]" />
                                                )}
                                            </button>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>


                    <div className="section_2">
                        <h1 className="title">{t("Register With Us")}</h1>
                        <div className="category_box" style={{ marginBottom: "0px" }}>
                            <div className="flex flex-wrap gap-4 justify-center">
                                {businessOrgData?.map((item, index) => {
                                    return (
                                        <div
                                            key={index}
                                            onClick={() => window.open(item.link, "_blank")}
                                            className="item_box1 cursor-pointer"
                                            style={{ padding: "5px" }}
                                        >
                                            <div className="business_img">
                                                <img src={item?.logo} width="40%" alt="" />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            {formList?.length > 0 && (
                                <div className="grid grid-cols-2 gap-4 mt-4">
                                    {formList?.map((item, index) => (
                                        <div
                                            key={index}
                                            onClick={() => navigate(`/form/${item.slug}`)}
                                            className={`
                                            item_box2 cursor-pointer p-3 bg-white rounded-xl shadow-sm
                                            ${index % 2 === 0 ? "col-span-2 mx-auto w-[70%]" : ""}
                                        `}
                                        >
                                            <div className="business_img flex justify-center">
                                                <img src={item?.logo} className="w-[80%]" alt="" />
                                            </div>

                                            <h5 className="mt-[10px] text-[16px] font-bold text-center">
                                                {item.title}
                                            </h5>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div >
        </div >
    )
}

export default BusinessUser
/* jshint ignore:end */
